import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import PasswordProtection from './components/PasswordProtection';
import ConsentBanner from './components/ConsentBanner';
import GA4StatusIndicator from './components/GA4StatusIndicator';
import { BookingProvider } from './contexts/BookingContext';
import { BookingPopup } from './components/BookingPopup';
import { useBooking } from './contexts/BookingContext';
import { useApi } from './hooks/useApi';
import { apiService, getCurrentLocale } from './services/api';

// Import pages
import Home from './pages/Home';
import Behandelingen from './pages/Behandelingen';
import OverOns from './pages/OverOns';
import Behandelzones from './pages/Behandelzones';
import Tarieven from './pages/Tarieven';
import Contact from './pages/Contact';
import AlgemeneVoorwaarden from './pages/AlgemeneVoorwaarden';
import PrivacyPolicy from './pages/PrivacyPolicy';

import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';

function AppContent() {
  const locale = getCurrentLocale();
  const { data: globalSettings } = useApi(apiService.getGlobalSettings, [locale]);
  const { isBookingPopupOpen, closeBookingPopup } = useBooking();

  useEffect(() => {
    const gs = (globalSettings as any)?.attributes ? (globalSettings as any).attributes : (globalSettings as any);
    const seo = gs?.seo;
    const siteName = gs?.siteName || 'Hairmedics';
    if (seo) {
      if (seo.metaTitle) {
        document.title = seo.metaTitle;
      } else {
        document.title = siteName;
      }
      const setMeta = (name: string, value?: string) => {
        if (!value) return;
        let tag = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
        if (!tag) {
          tag = document.createElement('meta');
          tag.setAttribute('name', name);
          document.head.appendChild(tag);
        }
        tag.setAttribute('content', value);
      };
      setMeta('description', seo.metaDescription);
      if (seo.keywords) setMeta('keywords', seo.keywords);
      if (seo.canonicalURL) {
        let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
        if (!link) {
          link = document.createElement('link');
          link.setAttribute('rel', 'canonical');
          document.head.appendChild(link);
        }
        link.setAttribute('href', seo.canonicalURL);
      }
    }
  }, [globalSettings]);

  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/behandelingen" element={<Behandelingen />} />
        <Route path="/over-ons" element={<OverOns />} />
        <Route path="/behandelzones" element={<Behandelzones />} />
        <Route path="/tarieven" element={<Tarieven />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/algemene-voorwaarden" element={<AlgemeneVoorwaarden />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
      <Footer />
      <ConsentBanner />
      <GA4StatusIndicator showDetails={true} />
      
      {/* Global Booking Popup */}
      <BookingPopup 
        isOpen={isBookingPopupOpen} 
        onClose={closeBookingPopup} 
      />
    </Router>
  );
}

function App() {
  return (
    <PasswordProtection>
      <BookingProvider>
        <AppContent />
      </BookingProvider>
    </PasswordProtection>
  );
}

export default App;
